import Cookies from 'js-cookie';
import OnLoadHelper from '@/scripts/old/helpers/OnLoadHelper';
import { parseAttr } from '@/scripts/old/helpers/utils';
import { findClosestElement } from '@/scripts/helpers/utils';

const NAMESPACE = 'data-header';
const DROP_ACTIVE_CLASS = '_active';
const FIXED_CLASS = '_fixed';
const NAV_ACTIVE_CLASS = '_nav-active';
const NOTICE_COOKIE_NAME = 'BITRIX_SM_APP_PROMO_IS_SHOWN';

class HeaderModule {
  constructor() {
    this.initialized = false;
    this.isFixed = false;
    this.isNavActive = false;

    this.onScrollShim = (e) => {
      this.onScroll(e);
    };

    this.onClickShim = (e) => {
      this.onClick(e);
    };

    OnLoadHelper.run(() => {
      this.init();
    });
  }

  init() {
    if (this.initialized) return;
    this.initialized = true;

    this.el = document.querySelector(`[${NAMESPACE}]`);
    this.content = this.el.querySelector(`[${NAMESPACE}-content]`);
    this.margin = document.querySelector(`[${NAMESPACE}-margin]`);
    this.contentHolder = this.el.querySelector(`[${NAMESPACE}-content-holder]`);
    this.filter = document.querySelector(`[${NAMESPACE}-filter]`);
    // this.notice = this.el.querySelector(`[${NAMESPACE}-notice]`);
    this.nav = this.el.querySelector(`[${NAMESPACE}-nav]`);
    this.navOverlay = this.el.querySelector(`[${NAMESPACE}-nav-overlay]`);

    this.onScroll();
    this.setEvents();
  }

  update() {
    this.init();
  }

  destroy() {
    this.setEvents(false);
    this.initialized = false;
  }

  setEvents(add = true) {
    const action = add ? 'addEventListener' : 'removeEventListener';
    document[action]('click', this.onClickShim);
    //window[action]('scroll', this.onScrollShim);
    window[action]('resize', this.onScrollShim);
  }
  
  onScroll() {
    if (document.documentElement.clientWidth > 1066) {
      this.nav.style.top = 0;
      this.navOverlay.style.top = 0;
      this.margin.style.height = 0;
    } else {
      const scroll = window.pageYOffset || document.documentElement.scrollTop;
      const contentTop = this.content.getBoundingClientRect().top;
      const contentOffset = contentTop + scroll;

      if (scroll >= contentOffset && !this.isFixed) {
        //this.contentHolder.style.height = `${this.content.offsetHeight}px`;
        this.el.classList.add(FIXED_CLASS);
        this.isFixed = true;
      } else if (scroll < contentOffset && this.isFixed) {
        //this.contentHolder.style.height = '';
        this.el.classList.remove(FIXED_CLASS);
        this.isFixed = false;
      }
      const navTop = this.isFixed
        ? `${this.content.offsetHeight}px`
        : `${this.el.offsetHeight + this.el.getBoundingClientRect().top}px`;
      this.nav.style.top = navTop;
      this.navOverlay.style.top = navTop;
  
      this.margin.style.height = navTop;

      if(this.filter) this.filter.style.top = navTop;
    }
  }

  onClick(e) {
    const navToggler = findClosestElement(e.target, `[${NAMESPACE}-nav-toggle]`);

    if (navToggler) {
      e.preventDefault();

      if (this.isNavActive) {
        this.el.classList.remove(NAV_ACTIVE_CLASS);
        this.isNavActive = false;
      } else {
        this.el.classList.add(NAV_ACTIVE_CLASS);
        this.isNavActive = true;
      }

      return;
    }

    const dropToggler = findClosestElement(e.target, `[${NAMESPACE}-drop-toggle]`);



    if (dropToggler) {
      e.preventDefault();
      const targetDrop = parseAttr(dropToggler, `${NAMESPACE}-drop-toggle`);

      const activeDropEl = this.el.querySelector(`[${NAMESPACE}-drop].${DROP_ACTIVE_CLASS}`);
      const targetDropEl = this.el.querySelector(`[${NAMESPACE}-drop="${targetDrop}"]`);

      if (activeDropEl) {
        activeDropEl.classList.remove(DROP_ACTIVE_CLASS);
      }

      if (targetDropEl && activeDropEl !== targetDropEl) {
        targetDropEl.classList.add(DROP_ACTIVE_CLASS);
      }
    }

//     const noticeRemove = findClosestElement(e.target, `[${NAMESPACE}-notice-remove]`);

//     if (noticeRemove) {
//       e.preventDefault();
//       const notice = this.el.querySelector(`[${NAMESPACE}-notice]`);

//       this.el.classList.remove('_notice-active');

//       Cookies.set(NOTICE_COOKIE_NAME, 'Y', { expires: 365, path: '/' });

//       if (notice) {
//         notice.parentElement.removeChild(notice);
//         this.onScroll();
//       }
//     }
  }
}

export default new HeaderModule();
